var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityStatusInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#D2D9ED",
    strokeWidth: 4,
    fill: "#D2D9ED",
    fillRule: "nonzero",
    cx: 15,
    cy: 15,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 15c0-6.075-4.925-11-11-11S4 8.925 4 15h22z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityStatusInProgress);
export default __webpack_public_path__ + "static/media/activity-status-in-progress.bfa96a38721cbd0150dd941e0c9492c3.svg";
export { ForwardRef as ReactComponent };